/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Created_SuccessInputs */

const en_task_created_success = /** @type {(inputs: Task_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task created successfully`)
};

const pt_br2_task_created_success = /** @type {(inputs: Task_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atividade criada com sucesso`)
};

/**
* | output |
* | --- |
* | "Task created successfully" |
*
* @param {Task_Created_SuccessInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_created_success = /** @type {((inputs?: Task_Created_SuccessInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Created_SuccessInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_created_success(inputs)
	return pt_br2_task_created_success(inputs)
});